import React, { useLayoutEffect, useState, useCallback } from "react";
import { motion } from "framer-motion";

const ImageExpand = ({ imgId, scrollOffset }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [originalPosition, setOriginalPosition] = useState({ x: 0, y: 0 });
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [imageSrc, setImageSrc] = useState("");
  const [currentScrollOffset, setCurrentScrollOffset] = useState(scrollOffset);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  // Function to update position and dimensions
  const updatePositionAndSize = useCallback(() => {
    const img = document.getElementById(imgId);
    if (img) {
      const rect = img.getBoundingClientRect();
      setOriginalPosition({
        x: rect.left,
        y: rect.top + scrollOffset,
      });
      setDimensions({ width: rect.width, height: rect.height });
      setImageSrc(img.src);
      setCurrentScrollOffset(scrollOffset);
    }
  }, [imgId, scrollOffset]);

  // Update position on mount and when dependencies change
  useLayoutEffect(() => {
    updatePositionAndSize();
    window.addEventListener("resize", updatePositionAndSize);
    window.addEventListener("scroll", updatePositionAndSize);

    return () => {
      window.removeEventListener("resize", updatePositionAndSize);
      window.removeEventListener("scroll", updatePositionAndSize);
    };
  }, [updatePositionAndSize]);

  return (
    <>
      {/* Transparent Hover Trigger */}
      <div
        style={{
          position: "absolute",
          top: originalPosition.y - currentScrollOffset,
          left: originalPosition.x,
          width: dimensions.width,
          height: dimensions.height,
          zIndex: 999,
          pointerEvents: "auto",
          background: "transparent",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      ></div>

      {/* Expandable Image */}
      <motion.div
        style={{
          position: "absolute",
          top: originalPosition.y - currentScrollOffset,
          left: originalPosition.x,
          width: dimensions.width,
          height: dimensions.height,
          zIndex: 1000,
          pointerEvents: "none",
        }}
        initial={{
          top: originalPosition.y - currentScrollOffset,
          left: originalPosition.x,
          width: dimensions.width,
          height: dimensions.height,
        }}
        animate={
          isHovered
            ? {
                width: dimensions.width * 5,
                height: dimensions.height * 5,
                top: "50%",
                left: "50%",
                x: "-50%",
                y: "-50%",
                opacity: 1,
              }
            : {
                width: dimensions.width,
                height: dimensions.height,
                top: originalPosition.y - currentScrollOffset,
                left: originalPosition.x,
                opacity: 0,
              }
        }
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {imageSrc && (
          <img src={imageSrc} alt="Expanded" style={{ width: "100%", height: "100%" }} />
        )}
      </motion.div>
    </>
  );
};

export default ImageExpand;
